import botanixLogo from '../svg/botanix-logo.png';
import { AddrMapType, MapType } from './types';

export const networkIcons: MapType = {
  3636: botanixLogo
}

export const stealthAddress: AddrMapType = {
  0: '0x0',
  // Deployed StealthAddress Contract on Botanix Testnet
  3636: '0xe7F7067C9ECAB27c5F7f13E02b13eD50931f6D0f'
}

export const explorer: MapType = {
  3636: 'blockscout.botanixlabs.dev'
}